import { render, staticRenderFns } from "./DxWeatherStatus.vue?vue&type=template&id=c06234ba&"
import script from "./DxWeatherStatus.vue?vue&type=script&lang=js&"
export * from "./DxWeatherStatus.vue?vue&type=script&lang=js&"
import style0 from "./DxWeatherStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports